export const sixDigitPostalPattern = "^[0-9]{6}$";
export const emailPattern = "[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}";
export const phoneNumberPattern = "^[0-9]*$";
export const sizePattern = "^[0-9]+.?[0-9]*|.[0-9]+$";
export const decimalNumber = /^[0-9]*\.?[0-9]{0,2}$/;
